import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAltOutlined";
import ThumbDownAltTwoToneIcon from "@mui/icons-material/ThumbDownTwoTone";
import ThumbUpAltTwoToneIcon from "@mui/icons-material/ThumbUpAltTwoTone";

export const marks = [
  {
    value: 0,
    label: "0",
  },
  {
    value: 20,
    label: "20",
  },
  {
    value: 40,
    label: "40",
  },
  {
    value: 60,
    label: "60",
  },
  {
    value: 80,
    label: "80",
  },
  {
    value: 100,
    label: "100",
  },
];

export const emojiIcons = {
  1: {
    icon: <SentimentDissatisfiedIcon color="inherit" />,
    label: "Dissatisfied",
  },
  2: {
    icon: <SentimentSatisfiedIcon color="inherit" />,
    label: "Neutral",
  },
  3: {
    icon: <SentimentSatisfiedAltIcon color="inherit" />,
    label: "Satisfied",
  },
};

export const thumbsIcon = {
  1: {
    icon: <ThumbUpAltTwoToneIcon className="thumbsUp" color="inherit" />,
    label: "Satisfied",
  },
  2: {
    icon: <ThumbDownAltTwoToneIcon className="thumbsDown" color="inherit" />,
    label: "Dissatisfied",
  },
};
